function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZipFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.096,
    height: 48,
    viewBox: "0 0 37.096 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59558",
    d: "M84.409 2H62.45a2.746 2.746 0 0 0-2.75 2.75v42.5A2.746 2.746 0 0 0 62.45 50h31.6a2.746 2.746 0 0 0 2.75-2.75V14.387z",
    style: {
      fill: "#fbe59e"
    },
    transform: "translate(-59.7 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59559",
    d: "M321.2 11.638a2.746 2.746 0 0 0 2.75 2.75h9.638L321.2 2z",
    transform: "translate(-296.491 -2)",
    style: {
      fill: "#d6c982"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18278"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59560",
    d: "M190.1 2h5.452v27.383H190.1z",
    transform: "translate(-177.779 -2)",
    style: {
      fill: "#445c6c"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18276"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59561",
    d: "M213.585 276.2s-.113.321-.359.321c-.217 0-.387-.274-.576-.274-.161 0-.35.208-.35.69s.18.69.35.69c.189 0 .368-.274.576-.274.246 0 .359.321.359.321h1.342V276.2z",
    transform: "translate(-197.882 -250.291)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59562",
    d: "M199.142 261.274s.113-.321.359-.321c.217 0 .387.274.576.274.161 0 .35-.208.35-.69s-.18-.69-.35-.69c-.189 0-.368.274-.576.274-.246 0-.359-.321-.359-.321H197.8v1.474z",
    transform: "translate(-184.752 -235.441)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59563",
    d: "M213.585 244s-.113.321-.359.321c-.217 0-.387-.274-.576-.274-.161 0-.35.208-.35.69s.18.69.35.69c.189 0 .368-.274.576-.274.246 0 .359.321.359.321h1.342V244z",
    transform: "translate(-197.882 -221.134)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59564",
    d: "M199.142 229.074s.113-.321.359-.321c.217 0 .387.274.576.274.161 0 .35-.208.35-.69s-.18-.69-.35-.69c-.189 0-.368.274-.576.274-.246 0-.359-.321-.359-.321H197.8v1.474z",
    transform: "translate(-184.752 -206.283)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59565",
    d: "M213.585 211.8s-.113.321-.359.321c-.217 0-.387-.274-.576-.274-.161 0-.35.208-.35.69s.18.69.35.69c.189 0 .368-.274.576-.274.246 0 .359.321.359.321h1.342V211.8z",
    transform: "translate(-197.882 -191.976)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59566",
    d: "M199.142 196.874s.113-.321.359-.321c.217 0 .387.274.576.274.161 0 .35-.208.35-.69s-.18-.69-.35-.69c-.189 0-.368.274-.576.274-.246 0-.359-.321-.359-.321H197.8v1.474z",
    transform: "translate(-184.752 -177.126)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59567",
    d: "M213.585 179.5s-.113.321-.359.321c-.217 0-.387-.274-.576-.274-.161 0-.35.208-.35.69s.18.69.35.69c.189 0 .368-.274.576-.274.246 0 .359.321.359.321h1.342V179.5z",
    transform: "translate(-197.882 -162.728)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59568",
    d: "M199.142 164.574s.113-.321.359-.321c.217 0 .387.274.576.274.161 0 .35-.208.35-.69s-.18-.69-.35-.69c-.189 0-.368.274-.576.274-.246 0-.359-.321-.359-.321H197.8v1.474z",
    transform: "translate(-184.752 -147.878)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59569",
    d: "M213.585 147.3s-.113.321-.359.321c-.217 0-.387-.274-.576-.274-.161 0-.35.208-.35.69s.18.69.35.69c.189 0 .368-.274.576-.274.246 0 .359.321.359.321h1.342V147.3z",
    transform: "translate(-197.882 -133.571)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59570",
    d: "M199.142 132.374s.113-.321.359-.321c.217 0 .387.274.576.274.161 0 .35-.208.35-.69s-.18-.69-.35-.69c-.189 0-.368.274-.576.274-.246 0-.359-.321-.359-.321H197.8v1.474z",
    transform: "translate(-184.752 -118.72)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59571",
    d: "M213.585 115.1s-.113.321-.359.321c-.217 0-.387-.274-.576-.274-.161 0-.35.208-.35.69s.18.69.35.69c.189 0 .368-.274.576-.274.246 0 .359.321.359.321h1.342V115.1z",
    transform: "translate(-197.882 -104.413)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59572",
    d: "M199.142 100.174s.113-.321.359-.321c.217 0 .387.274.576.274.161 0 .35-.208.35-.69s-.18-.69-.35-.69c-.189 0-.368.274-.576.274-.246 0-.359-.321-.359-.321H197.8v1.474z",
    transform: "translate(-184.752 -89.563)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59573",
    d: "M213.585 82.9s-.113.321-.359.321c-.217 0-.387-.274-.576-.274-.161 0-.35.208-.35.69s.18.69.35.69c.189 0 .368-.274.576-.274.246 0 .359.321.359.321h1.342V82.9z",
    transform: "translate(-197.882 -75.256)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59574",
    d: "M199.142 67.974s.113-.321.359-.321c.217 0 .387.274.576.274.161 0 .35-.208.35-.69s-.18-.69-.35-.69c-.189 0-.368.274-.576.274-.246 0-.359-.321-.359-.321H197.8v1.474z",
    transform: "translate(-184.752 -60.406)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59575",
    d: "M213.585 50.6s-.113.321-.359.321c-.217 0-.387-.274-.576-.274-.161 0-.35.208-.35.69s.18.69.35.69c.189 0 .368-.274.576-.274.246 0 .359.321.359.321h1.342V50.6z",
    transform: "translate(-197.882 -46.008)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59576",
    d: "M199.142 35.674s.113-.321.359-.321c.217 0 .387.274.576.274.161 0 .35-.208.35-.69s-.18-.69-.35-.69c-.189 0-.368.274-.576.274-.246 0-.359-.321-.359-.321H197.8v1.474z",
    transform: "translate(-184.752 -31.157)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59577",
    d: "M213.585 18.4s-.113.321-.359.321c-.217 0-.387-.274-.576-.274-.161 0-.35.208-.35.69s.18.69.35.69c.189 0 .368-.274.576-.274.246 0 .359.321.359.321h1.342V18.4z",
    transform: "translate(-197.882 -16.85)",
    style: {
      fill: "#dbdfe0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59578",
    d: "M199.142 3.474s.113-.321.359-.321c.217 0 .387.274.576.274.161 0 .35-.208.35-.69s-.18-.69-.35-.69c-.189 0-.368.274-.576.274-.246 0-.359-.321-.359-.321H197.8v1.474z",
    transform: "translate(-184.752 -2)",
    style: {
      fill: "#dbdfe0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18277"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59579",
    d: "m178.691 294.127-1.342-4.12v-3.666a.843.843 0 0 0-.841-.841H172.1a.843.843 0 0 0-.841.841v3.666l-1.351 4.129a4.631 4.631 0 1 0 9.024 1.465 4.232 4.232 0 0 0-.241-1.474zm-4.384 4.517a3.043 3.043 0 1 1 3.043-3.043 3.041 3.041 0 0 1-3.043 3.042z",
    transform: "translate(-159.274 -258.713)",
    style: {
      fill: "#aeb0b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59580",
    d: "M210.65 285.6a.847.847 0 0 0-.85.85v2.75a.85.85 0 1 0 1.7 0v-2.75a.853.853 0 0 0-.85-.85z",
    transform: "translate(-195.618 -258.804)",
    style: {
      fill: "#445c6c"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipFolder);
export default __webpack_public_path__ + "static/media/zip-folder.467112d9093ea6bda25707a75ced0e36.svg";
export { ForwardRef as ReactComponent };